<template>
  <div class="baiduQueue">
    <div class="fromClass2">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label="贷款人姓名">
          <el-input v-model="searchData.name"></el-input>
        </el-form-item>
        <el-form-item label="贷款人联系电话">
          <el-input v-model="searchData.tel"></el-input>
        </el-form-item>
        <el-form-item label="贷后管理人员">
          <el-select v-model="searchData.managerAdminId" clearable>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in allManagerList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="贷款类型">
          <el-select v-model="searchData.loanType" clearable>
            <el-option label="房屋抵押" value="房屋抵押"></el-option>
            <el-option label="信用贷款" value="信用贷款"></el-option>
            <el-option label="小微企业贷款" value="小微企业贷款"></el-option>
            <el-option label="汽车贷款" value="汽车贷款"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <div></div>
      <div>
        <el-button-group>
          <!-- <el-button type="primary" size="small" @click="derive">导出</el-button> -->
          <el-button type="primary" size="small" @click="refresh"
            >查询</el-button
          >
        </el-button-group>
      </div>
    </div>
    <div class="tableClass">
      <template>
        <el-table
          ref="multipleTable"
          :data="list.list"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.customer_name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.customer_tel
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="贷款类型">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.loan_type
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="贷款金额">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column label="贷款机构">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.loan_company
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="放款日期">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.get_day
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="到期日期">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.due_date
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="还款方式">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.repayment_type
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="录单人员">
            <template slot-scope="scope">
              <span :style="getRowStyle(scope.row)">{{
                scope.row.salesman
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="editState(scope.row)"
              >
                {{ scope.row.state == 2 ? "取消加急" : "加急" }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="1"
          :page-sizes="[10, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.totalRow"
          size="small"
        ></el-pagination>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      list: {
        list: [],
        totalRow: 0,
      },
      searchData: {
        name: "",
        tel: "",
        managerAdminId: "",
        loanType: "",
      },
      allManagerList: [],
    };
  },
  created() {
    this.getData();
    this.getManagerList();
  },
  methods: {
    getRowStyle(row) {
      console.log(row.state);
      if (row.state == 2) {
        return { color: "red" };
      }
      return {};
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    refresh() {
      this.page = 1;
      this.getData();
    },
    derive() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.searchData.name,
        tel: this.searchData.tel,
        managerAdminId: this.searchData.managerAdminId,
        loanType: this.searchData.loanType,
        needDue: 120,
        isExport: 1,
        sort: "due_date",
      };
      this.$axios
        .post("/api/loan_information/getList", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.code == 1) {
            const a = document.createElement("a");
            let url = res.data.data;
            a.setAttribute("download", "");
            a.setAttribute("href", url);
            a.click();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getData() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.searchData.name,
        tel: this.searchData.tel,
        managerAdminId: this.searchData.managerAdminId,
        loanType: this.searchData.loanType,
        needDue: 120,
        sort: "due_date",
      };
      this.$axios
        .post("/api/loan_information/getList", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.code == 1) {
            this.list = res.data.data;
          }
        });
    },
    editState(row) {
      const actionText = row.state == 2 ? "取消加急" : "加急";
      this.$confirm(`确定${actionText}该客户吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              "/api/loan_information/editState",
              this.$qs.stringify({ id: row.id }),
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    getManagerList() {
      this.$axios.post("/api/loan_information/allManager").then((res) => {
        this.allManagerList = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.baiduQueue {
  width: calc(100% - 40px);
  padding: 20px 0;
  min-height: 680px;
}
.fromClass2 {
  width: 90%;
  height: auto;
  margin: 10px auto;
  padding: 10px 0;
  display: flex;
  align-content: center;
}
.btn {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tableClass {
  width: 90%;
  margin: 0 auto;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/expiringCustomers/index.vue